import { createFileRoute } from '@tanstack/react-router'
import { ReservationsPage } from '@/features/hospitality/pages/ReservationsPage'

export const Route = createFileRoute('/_app/hospitality/reservations')({
  component: ReservationsPage,
})
